var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledRejection({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.20296 6C7.01132 6 6.81091 6.06446 6.66465 6.2106C6.3722 6.50364 6.3722 6.99528 6.66465 7.28832L11.3688 11.9957L6.66465 16.7031C6.3722 16.9961 6.3722 17.4877 6.66465 17.7808C6.95717 18.0731 7.44875 18.0731 7.74128 17.7808L12.4453 13.0734L17.1493 17.7808C17.4419 18.0731 17.9335 18.0731 18.226 17.7808C18.5184 17.4877 18.5184 16.9961 18.226 16.7031L13.5219 11.9957L18.226 7.28832C18.5184 6.99528 18.5184 6.50364 18.226 6.2106C18.0797 6.06446 17.8792 6 17.6877 6C17.496 6 17.2957 6.06446 17.1493 6.2106L12.4453 10.918L7.74128 6.2106C7.59502 6.06446 7.39461 6 7.20296 6Z",
    fill: "#AAACAE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledRejection);
export default __webpack_public_path__ + "static/media/disabled-rejection.427de363c76bb595ee1cc5fdf969c7b9.svg";
export { ForwardRef as ReactComponent };